import { render, staticRenderFns } from "./keyPerson.vue?vue&type=template&id=0da054a6&scoped=true&"
import script from "./keyPerson.vue?vue&type=script&lang=js&"
export * from "./keyPerson.vue?vue&type=script&lang=js&"
import style0 from "./keyPerson.vue?vue&type=style&index=0&id=0da054a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da054a6",
  null
  
)

export default component.exports